export class LearningOfferModel {
  Address:  string;
  City:  string;
  Company_name:  string;
  Contract_duration:  string;
  Contract_type:  string;
  CreatedAt:  string;
  Diploma_targeted:  string;
  Email:  string;
  File:  string;
  Firstname:  string;
  Id:  string;
  Job_title:  string;
  Lastname:  string;
  Phone_number:  string;
  Postal_code:  string;
  Prerequisites_and_missions:  string;
  Service_name:  string;
  Social_reason:  string;
  IsNew: Boolean;

  public mapToModel(data): LearningOfferModel {
    const learningOfferModel = new LearningOfferModel();
    learningOfferModel.Id = data.id;
    learningOfferModel.City = data.city;
    learningOfferModel.Company_name = data.company_name;
    learningOfferModel.Contract_duration = data.contract_duration;
    learningOfferModel.Contract_type = data.contract_type;
    learningOfferModel.CreatedAt = data.createdAt;
    learningOfferModel.Email = data.email;
    learningOfferModel.Diploma_targeted = data.diploma_targeted;
    learningOfferModel.File = data.file;
    learningOfferModel.Firstname = data.firstname;
    learningOfferModel.Lastname = data.lastname;
    learningOfferModel.Job_title = data.job_title;
    learningOfferModel.Phone_number = data.phone_number;
    learningOfferModel.Address = data.address;
    learningOfferModel.Postal_code = data.postal_code;
    learningOfferModel.Prerequisites_and_missions =
      data.prerequisites_and_missions;
    learningOfferModel.Service_name = data.service_name;
    learningOfferModel.Social_reason = data.social_reason;

    return learningOfferModel;
  }
}
